/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingRequestExtra } from '../models/BookingRequestExtra';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingRequestsExtraService {

    /**
     * @returns BookingRequestExtra
     * @throws ApiError
     */
    public static bookingRequestsExtraCreate({
        requestId,
        requestBody,
    }: {
        requestId: string,
        requestBody?: BookingRequestExtra,
    }): CancelablePromise<BookingRequestExtra> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/booking-requests-extra/{request_id}/',
            path: {
                'request_id': requestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
